import React, { Component } from 'react'

export default class TrendingProducts extends Component {
  render() {
    return (
      <div>TrendingProducts</div>
    )
  }
}
